/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorization-form.vue?vue&type=template&id=113b17ce&scoped=true&"
import script from "./authorization-form.vue?vue&type=script&lang=ts&"
export * from "./authorization-form.vue?vue&type=script&lang=ts&"
import style0 from "./authorization-form.vue?vue&type=style&index=0&id=113b17ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b17ce",
  null
  
)

export default component.exports